import Chart from './Chart';

import './_league-table-chart.scss';

export default Chart;
